/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Start_Aria_LabelInputs */

const en_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start project import`)
};

const fr_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer l’importation du projet`)
};

const de_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport starten`)
};

const it_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia l'importazione del progetto`)
};

const ru_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать импорт проекта`)
};

const es_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar la importación del proyecto`)
};

const zh_cn2_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始项目导入`)
};

const ja_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートを開始`)
};

const hi_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात शुरू करें`)
};

const pt_pt2_team_project_import_start_aria_label = /** @type {(inputs: Team_Project_Import_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar importação de projeto`)
};

/**
* | output |
* | --- |
* | "Start project import" |
*
* @param {Team_Project_Import_Start_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_start_aria_label = /** @type {((inputs?: Team_Project_Import_Start_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Start_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_start_aria_label(inputs)
	if (locale === "de") return de_team_project_import_start_aria_label(inputs)
	if (locale === "it") return it_team_project_import_start_aria_label(inputs)
	if (locale === "ru") return ru_team_project_import_start_aria_label(inputs)
	if (locale === "es") return es_team_project_import_start_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_start_aria_label(inputs)
	if (locale === "ja") return ja_team_project_import_start_aria_label(inputs)
	if (locale === "hi") return hi_team_project_import_start_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_start_aria_label(inputs)
	return en_team_project_import_start_aria_label(inputs)
});